<mat-card class="restricted-text helper-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>
        <span>{{ helperTexts().restrictedTitle }}</span>
      </mat-card-title>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content class="helper-content">{{ helperTexts().restrictedDescription }}</mat-card-content>
</mat-card>
<mat-card class="high-risk-text helper-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>
        <span>{{ helperTexts().highRiskTitle }}</span>
      </mat-card-title>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content class="helper-content">{{ helperTexts().highRiskDescription }}</mat-card-content>
</mat-card>
<mat-card class="medium-risk-text helper-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>
        <span>{{ helperTexts().mediumRiskTitle }}</span>
      </mat-card-title>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content class="helper-content">{{ helperTexts().mediumRiskDescription }}</mat-card-content>
</mat-card>
<div>
  <div>{{ helperTexts().footerNote }}</div>
</div>
